import React from 'react'
import {graphql} from 'gatsby'
import Layout from '../components/Layout'
import PageTitle from '../components/PageTitle';
import PageDesc from '../components/PageDescription';
import ProductList from "../components/products/ProductList";

const ProductPageTemplate = ({
                                        title,
                                        description,
                                    }
) => (
    <div>
        <PageTitle>{title}</PageTitle>
        <PageDesc>{description}</PageDesc>
        <ProductList/>
    </div>
);

const ProductPage = ({data}) => {

    const {frontmatter} = data.markdownRemark;

    return (
        <Layout>
            <ProductPageTemplate
                title={frontmatter.title}
                description={frontmatter.description}
            />
        </Layout>
    )
};

export default ProductPage

export const exhibitionPageQuery = graphql`
    query WystawaPageQuery{
        markdownRemark(frontmatter: {templateKey: {eq: "product-page"}}) {
            frontmatter {
                templateKey
                title
                description
            }
        }
    }
`;
